module.exports = __webpack_public_path__ + "static/media/service-guarantee.41b825f2.webp";